import React from 'react';
import { Menu, X } from 'lucide-react';
import classNames from 'classnames';
import IconButton from '@client/components/designSystem/iconButton/IconButton';
import { SIDEBAR_ID, TOP_BAR_ACTIONS_ID } from './AdminNavigation';
import CountrySelector from './CountrySelector';
import SidebarBrand from './SidebarBrand';
import SidebarNavigation from './SidebarNavigation';
import useAdminSidebar from './useAdminSidebar';
import useSidebarDrawer from './useSidebarDrawer';
import styles from './adminSidebar.scss';

// The navigation for every admin page. A fixed sidebar on wide screens; on
// narrow screens it is a drawer opened from a button in a top bar.
function AdminSidebar() {
  const { sections, policies, settings, countryFilter } = useAdminSidebar();
  const drawer = useSidebarDrawer();

  return (
    <div className={styles.root}>
      <header className={styles.topBar}>
        <IconButton
          ref={drawer.menuButtonRef}
          label="Open menu"
          icon={<Menu />}
          aria-expanded={drawer.isOpen}
          aria-controls={SIDEBAR_ID}
          onClick={drawer.toggle}
        />
        <div id={TOP_BAR_ACTIONS_ID} className={styles.topBarActions} />
      </header>
      {drawer.isOpen && (
        <div
          className={styles.backdrop}
          data-testid="sidebar-backdrop"
          aria-hidden="true"
          onClick={drawer.close}
        />
      )}
      <aside
        id={SIDEBAR_ID}
        ref={drawer.sidebarRef}
        aria-label="Sidebar"
        className={classNames(styles.sidebar, drawer.isOpen && styles.open)}
        onKeyDown={drawer.handleKeyDown}
      >
        <IconButton
          label="Close menu"
          icon={<X />}
          className={styles.closeButton}
          onClick={drawer.close}
        />
        <SidebarBrand onNavigate={drawer.close} />
        <SidebarNavigation
          sections={sections}
          policies={policies}
          settings={settings}
          onNavigate={drawer.close}
        />
        <div className={styles.country}>
          <CountrySelector
            selected={countryFilter.selected}
            onToggle={countryFilter.toggle}
            onClose={countryFilter.commit}
          />
        </div>
      </aside>
    </div>
  );
}

export default AdminSidebar;
